import moment from 'moment';
import { getFilterValueByKey } from '../searchHelpers';

export const makeDateFilter = (searchRequest) => {
  const filterValue = getFilterValueByKey(searchRequest.date);
  let filterParams = [];
  // Do not set filter to all, this results in an invalid request
  if (filterValue.play && filterValue.play === 'all') {
    return filterParams;
  }

  if (filterValue.play === 'range') {
    // Only construct range filter if bounds are set
    if (!searchRequest.dateFrom || !searchRequest.dateTo) {
      return filterParams;
    }
    filterParams.push({
      param: 'publishedDateFrom',
      value: searchRequest.dateFrom,
    });
    filterParams.push({
      param: 'publishedDateTo',
      value: searchRequest.dateTo,
    });
  } else {
    filterParams.push({ param: 'publishedDateFrom', value: filterValue.play });
    filterParams.push({
      param: 'publishedDateTo',
      value: moment().format('YYYY-MM-DD'),
    });
  }

  return filterParams;
};

export const makePageSizeFilter = (pageSize) => {
  let filterParams = [];
  filterParams.push({ param: 'pageSize', value: pageSize * 1 });
  return filterParams;
};

export const makeKeywordFilter = (keyword) => {
  let filterParams = [];
  filterParams.push({ param: 'q', value: keyword });
  return filterParams;
};

export const makeMediaTypeFilter = (mediaType) => {
  let filterParams = [];
  // Allow all media types
  if (!mediaType) {
    return filterParams;
  }
  filterParams.push({ param: 'mediaType', value: mediaType });
  return filterParams;
};
